/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_ExportInputs */

const vi_movement_breakdown_export = /** @type {(inputs: Movement_Breakdown_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel`)
};

/**

* @param {Movement_Breakdown_ExportInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_export = /** @type {((inputs?: Movement_Breakdown_ExportInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_ExportInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_export(inputs)
});